import { getAnalyticsInstance } from './config';

// Export Analytics using lazy initialization with Proxy
// This ensures Analytics is initialized only when accessed, preventing chunking issues
let _analyticsInstance: ReturnType<typeof getAnalyticsInstance> | null = null;

export const Analytics = new Proxy({} as NonNullable<ReturnType<typeof getAnalyticsInstance>>, {
    get(_target, prop) {
        if (!_analyticsInstance) {
            _analyticsInstance = getAnalyticsInstance();
        }
        if (!_analyticsInstance) {
            return undefined;
        }
        return (_analyticsInstance as any)[prop];
    },
    has(_target, prop) {
        if (!_analyticsInstance) {
            _analyticsInstance = getAnalyticsInstance();
        }
        return _analyticsInstance ? prop in (_analyticsInstance as any) : false;
    },
    ownKeys(_target) {
        if (!_analyticsInstance) {
            _analyticsInstance = getAnalyticsInstance();
        }
        return _analyticsInstance ? Object.keys(_analyticsInstance as any) : [];
    },
    getOwnPropertyDescriptor(_target, prop) {
        if (!_analyticsInstance) {
            _analyticsInstance = getAnalyticsInstance();
        }
        return _analyticsInstance ? Object.getOwnPropertyDescriptor(_analyticsInstance as any, prop) : undefined;
    }
}) as ReturnType<typeof getAnalyticsInstance>;
